/* facet-drawer-fullscreen.js
   ----------------------------------------------------------------
   Make <facet-drawer> behave like the navigation drawer on mobile:
   slide in from the left and fill the viewport, instead of the
   theme's default behavior of forcing every drawer to slide up
   from the bottom on small screens.

   Why a JS shim:
   - The base `Drawer` class in theme.js hardcodes
     `openFrom = "bottom"` whenever the viewport matches `sm-max`,
     ignoring the element's `open-from` attribute. (theme.js
     ~line 1467.)
   - That single getter controls BOTH the slide-direction clip-path
     animation AND the inline `left/right/top/bottom` positioning.
     There's no CSS hook to override it.
   - `<navigation-drawer>` already subclasses `Drawer` and overrides
     this getter to honor `mobile-opening`. We do the equivalent for
     `<facet-drawer>` here without touching theme.js, so theme
     upgrades stay clean.

   Behavior after patching:
   - `<facet-drawer open-from="left">` slides in from the left on
     mobile (and stays on the left on desktop, unchanged).
   - All other drawers (`cart-drawer`, `quick-buy-drawer`, etc.)
     remain on their default bottom-sheet mobile behavior — only
     `facet-drawer` is patched.

   The companion full-screen styling lives in
   `sections/main-collection.liquid` and `sections/main-search.liquid`
   (the two sections that mount a `<facet-drawer>`). The styling is
   a no-op without this shim, because the JS-set inline left/right
   styles would still pin the drawer to the bottom-right corner.
*/
customElements.whenDefined('facet-drawer').then((FacetDrawer) => {
  Object.defineProperty(FacetDrawer.prototype, 'openFrom', {
    get() {
      /* Always honor the attribute. The parent class drops it on
         mobile in favor of "bottom"; we don't. */
      return this.getAttribute('open-from') || 'right';
    },
    configurable: true,
  });
});
